import React, { FC } from 'react'
import Modal from 'react-modal'

import AddEnergyMotionRecord from './components/AddOrEditEnergyMotionRecord'
import AddEnergyRecord from './components/AddOrEditEnergyRecord'
import JournalFavorites from './components/JournalFavorites'

import { IconName } from 'Components/Icon'
import { IconButton } from 'Components/IconButton'
import JournalSearch from 'Components/JournalSearch/JournalSearch'
import SidebarNavigation, { NavigationItem } from 'Components/SidebarNavigation/SidebarNavigation'
import { MealCategory } from 'Models'
import { useAppDispatch, useAppSelector } from 'ReduxStore/hooks'
import { currentJournalDateSelector } from 'ReduxStore/journalDay'
import { addJournalEnergyMotionRecordAction } from 'ReduxStore/journalEnergyMotionRecords'
import { addJournalEnergyRecordAction } from 'ReduxStore/journalEnergyRecords'
import { modalZIndexPriority } from 'Utils/zIndexPriority'

export type AddModalView = 'search' | 'favorites' | 'energy' | 'energyMotion'

const NAV_ITEMS: NavigationItem[] = [
  { target: 'search', icon: IconName.search, label: 'Suche' },
  { target: 'favorites', icon: IconName.heart, label: 'Favoriten' },
  { target: 'energy', icon: IconName.utensils, label: 'Mahlzeit direkt eintragen' },
  { target: 'energyMotion', icon: IconName.weight, label: 'Aktivität direkt eintragen' }
]

type Props = {
  isOpen: boolean
  activeView: AddModalView
  onViewChange: (view: AddModalView) => void
  onClose: () => void
}

const JournalAddModal: FC<Props> = ({ isOpen, activeView, onViewChange, onClose }) => {
  const dispatch = useAppDispatch()
  const date = useAppSelector(currentJournalDateSelector)

  const addJournalEnergyRecord = (description: string, energy: number, mealCategory: MealCategory): void => {
    dispatch(addJournalEnergyRecordAction(description, energy, mealCategory, date))
  }

  const addJournalEnergyMotionRecord = (description: string, energy: number, duration: number): void => {
    dispatch(addJournalEnergyMotionRecordAction(description, energy, duration, date))
  }

  return isOpen ? (
    <Modal style={modalZIndexPriority} isOpen={isOpen} onRequestClose={onClose} ariaHideApp={false}>
      <div className="modal is-large toolbar-modal">
        <div className="toolbar-modal-header">
          <div className="row justify-content-between align-items-center p-2">
            <h2>Zum Tagebuch hinzufügen</h2>
            <IconButton name={IconName.close} onClick={onClose} />
          </div>
        </div>

        <div className="toolbar-modal-layout">
          <div className="p-2">
            <SidebarNavigation
              navigationItems={NAV_ITEMS}
              activeTarget={activeView}
              onItemClick={(target) => onViewChange(target as AddModalView)}
            />
          </div>

          <div className="journal-add-modal-content">
            {activeView === 'search' && <JournalSearch onSaveSearchResult={onClose} />}
            {activeView === 'favorites' && <JournalFavorites onClose={onClose} />}
            {activeView === 'energy' && (
              <div className="toolbar-modal-body mt-2 mr-1">
                <div className="basiccard px-4 pt-4 pb-3">
                  <AddEnergyRecord onClose={onClose} addJournalEnergyRecord={addJournalEnergyRecord} resetOnClose />
                </div>
              </div>
            )}
            {activeView === 'energyMotion' && (
              <div className="toolbar-modal-body mt-2 mr-1">
                <div className="basiccard px-4 pt-4 pb-3">
                  <AddEnergyMotionRecord
                    onClose={onClose}
                    addJournalEnergyMotionRecord={addJournalEnergyMotionRecord}
                    resetOnClose
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  ) : null
}

export default JournalAddModal
